import React, { useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ROUTES } from 'shared/constants/routes';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import TermsAndConditionDialog from 'components/TermsAndCondition';
import logo from 'assets/images/shirtly_logo.svg';
import CADFlag from 'assets/images/canada-flag.png';
import USAFlag from 'assets/images/usa-flag.png';

import {
  Container,
  NavLinks,
  Link,
  ContactInfo,
  SocialLinks,
  Wrapper,
  LinkBtn,
  Address,
  FooterLogo,
  Icon,
  Terms,
} from 'styles/pages/home/footer';

const Footer = () => {
  const [termsDialog, setTermsDialog] = useState(false);
  return (
    <Container>
      <Wrapper>
        <NavLinks>
          {/*<a href="#products-pricing">Products & Pricing</a>
          <a href="#whats-new">What's new</a>
          <a href="#how-it-works">How it Works</a>
          <a href="#key-features">Key Features</a>
          <a href="#product-bundling">Product Bundling</a>*/}
          <ReactRouterLink to={ROUTES.NEWS_ROOM.LINK}>Newsroom</ReactRouterLink>
        </NavLinks>
        <ContactInfo>
          <div>
            <LinkBtn href="mailto:info@bigoventees.com">
              <EmailIcon fontSize="large" />
              <span>Email</span>
            </LinkBtn>
            <p>info@bigoventees.com</p>
          </div>
          <div>
            <LinkBtn>
              <LocationOnIcon fontSize="large" />
              <span>Visit</span>
            </LinkBtn>
            <Address>
              <div>
                <p>122 Middleton St.</p>
                <p> Brantford, ON N3S 7V7,</p>
                <p>
                  Canada <img src={CADFlag} alt="flag" />
                </p>
              </div>
              <div>
                <p>8742 Buffalo Ave,</p>
                <p> Niagara Falls, NY 14304,</p>
                <p>
                  United States <img src={USAFlag} alt="flag" />
                </p>
              </div>
            </Address>
          </div>
        </ContactInfo>
        <SocialLinks>
          <FooterLogo>
            <img src="https://bigoventees.com/img/footer.png" alt="logo" />
          </FooterLogo>
          {/*<Icon>
            <a
              href="https://www.facebook.com/shirtlyfulfillment/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon fontSize="large" />
            </a>
            <a
              href="https://www.instagram.com/shirtlyfulfillment"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon fontSize="large" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCfrwoaXOIDukx_cMzedSXxg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon fontSize="large" />
            </a>
          </Icon>*/}
        </SocialLinks>
      </Wrapper>
      <Terms>
        <p>
          © 2020 Design by Big Oven Tees /
          <span onClick={() => setTermsDialog(true)}>
            Terms of Service / Privacy Policy
          </span>
        </p>
      </Terms>
      {termsDialog && (
        <TermsAndConditionDialog
          open={termsDialog}
          setOpen={(v) => setTermsDialog(v)}
        />
      )}
    </Container>
  );
};

export default Footer;
